import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/components/pages/authentication/authentication/authentication.service';
import { ProductionDetailResult } from 'src/app/models/production';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductionProcessService } from 'src/app/services/production-process.service';
import { ProductionService } from 'src/app/services/production.service';

interface DetailTemp {
  id: number;
  productionId: number;
  realQuantity: number;
  realCost: number;
  totalCostReal: number;
}

@Component({
  selector: 'app-production-details-result',
  templateUrl: './production-details-result.component.html',
  styleUrls: ['./production-details-result.component.scss']
})

export class ProductionDetailsResultComponent {
  @Input() detailsResult: ProductionDetailResult[] = [];
  @Input() productionId: number;
  editing: { [key: number]: boolean } = {};
  detailTemp: { [key: number]: DetailTemp } = {};

  constructor(
    private toastService: ToastrService,
    private productionService: ProductionService,
    private productionProcessService: ProductionProcessService,
    private authService: AuthenticationService,
  ) { }

  setEditing(item: ProductionDetailResult) {
    this.editing[item.id] = true;
    this.detailTemp[item.id] = {
      id: item.id,
      productionId: item.productionId,
      realQuantity: item.realQuantity,
      realCost: item.realCost,
      totalCostReal: item.totalCostReal
    }
  }

  changeInput(item: ProductionDetailResult) {
    item.totalCostReal = item.realQuantity * item.realCost;
  }

  cancelEditing(item: ProductionDetailResult) {
    this.editing[item.id] = false;
    item.realQuantity = this.detailTemp[item.id].realQuantity;
    item.realCost = this.detailTemp[item.id].realCost;
    item.totalCostReal = this.detailTemp[item.id].totalCostReal;
  }

  saveChanges(item: ProductionDetailResult) {
    const data = {
      quantity: item.realQuantity,
      cost: item.realCost
    }

    this.productionProcessService.updateQuantityCostProductionResult(item.id, data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Datos Actualizados Correcta", "Exito");
        this.editing[item.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Erro al actualizar los datos", "Error");
      }
    });
  }

}
